import React, { useContext, useEffect, useState } from 'react';
import { BellSnoozeIcon, XMarkIcon } from '@heroicons/react/24/outline';

import {
	TemplateBoolean,
	TemplateDropdown,
	TemplateTeamMembers,
} from '../../../components/Attributes/Attributes_old';
import useAsync from '../../../hooks/useAsync';
import { getTeam } from '../../../api/company';
import SettingsContext from '../../../context/SettingsContext';
import { getUserFullName } from '../../../components/helpers/functions';
import { AvatarGenerated } from '../../../components/Avatar';
import Button from '../../../components/Button';
import BetaAttributes from '../../../components/Attributes';
import { NOTIFY_OPTIONS } from '../../../constants';
import { Routes } from '@headlessui/react';

const NotificationSettings = () => {
	const [form, setForm] = useState({
		time: 30,
		renotify: 7,
		overdue: true,
		admin: true,
		scheduled: { value: '6:0' },
		members: [],
	});

	const [contractForm, setContractForm] = useState({
		time: 30,
		renotify: 7,
		overdue: true,
		admin: true,
		scheduled: { value: '6:0' },
		members: [],
	});

	const {
		settings,
		loading: isLoadingSettings,
		updating: isUpdatingSettings,
		refresh: refreshSettings,
		update: updateSettings,
	} = useContext(SettingsContext);

	const { value: teamMembers } = useAsync(getTeam);

	useEffect(() => {
		if (
			(settings,
			typeof settings?.company?.serviceNotifications?.time !== undefined ||
				typeof settings?.company?.serviceNotifications?.renotify !==
					undefined ||
				typeof settings?.company?.serviceNotifications?.overdue !== undefined ||
				typeof settings?.company?.serviceNotifications?.admin !== undefined ||
				typeof settings?.company?.serviceNotifications?.scheduled !==
					undefined ||
				typeof settings?.company?.serviceNotifications?.members !== undefined)
		) {
			setForm({
				...(typeof settings?.company?.serviceNotifications?.time !== 'undefined'
					? { time: settings?.company?.serviceNotifications?.time }
					: { time: form?.time }),

				...(typeof settings?.company?.serviceNotifications?.renotify !==
				'undefined'
					? { renotify: settings?.company?.serviceNotifications?.renotify }
					: { renotify: form?.renotify }),

				...(typeof settings?.company?.serviceNotifications?.scheduled !==
				'undefined'
					? {
							scheduled: {
								value: settings?.company?.serviceNotifications?.scheduled,
							},
					  }
					: { scheduled: form?.scheduled }),
				...(typeof settings?.company?.serviceNotifications?.overdue !==
				'undefined'
					? { overdue: settings?.company?.serviceNotifications?.overdue }
					: { overdue: form?.overdue }),
				...(typeof settings?.company?.serviceNotifications?.admin !==
				'undefined'
					? { admin: settings?.company?.serviceNotifications?.admin }
					: { admin: form?.admin }),
				...(typeof settings?.company?.serviceNotifications?.members !==
				'undefined'
					? { members: settings?.company?.serviceNotifications?.members }
					: { members: form?.members }),
			});
		}

		if (
			(settings,
			typeof settings?.company?.contractNotifications?.time !== undefined ||
				typeof settings?.company?.contractNotifications?.renotify !==
					undefined ||
				typeof settings?.company?.contractNotifications?.overdue !==
					undefined ||
				typeof settings?.company?.contractNotifications?.admin !== undefined ||
				typeof settings?.company?.contractNotifications?.scheduled !==
					undefined ||
				typeof settings?.company?.contractNotifications?.members !== undefined)
		) {
			setContractForm({
				...(typeof settings?.company?.contractNotifications?.time !==
				'undefined'
					? { time: settings?.company?.contractNotifications?.time }
					: { time: contractForm?.time }),

				...(typeof settings?.company?.contractNotifications?.renotify !==
				'undefined'
					? { renotify: settings?.company?.contractNotifications?.renotify }
					: { renotify: contractForm?.renotify }),

				...(typeof settings?.company?.contractNotifications?.scheduled !==
				'undefined'
					? {
							scheduled: {
								value: settings?.company?.contractNotifications?.scheduled,
							},
					  }
					: { scheduled: contractForm?.scheduled }),
				...(typeof settings?.company?.contractNotifications?.overdue !==
				'undefined'
					? { overdue: settings?.company?.contractNotifications?.overdue }
					: { overdue: contractForm?.overdue }),
				...(typeof settings?.company?.contractNotifications?.admin !==
				'undefined'
					? { admin: settings?.company?.contractNotifications?.admin }
					: { admin: contractForm?.admin }),
				...(typeof settings?.company?.contractNotifications?.members !==
				'undefined'
					? { members: settings?.company?.contractNotifications?.members }
					: { members: contractForm?.members }),
			});
		}
	}, [settings]);

	return (
		<>
			<div>
				<h2 className="text-base font-semibold leading-6 text-gray-900">
					Notification Settings
				</h2>
				<dl className="mt-6 space-y-2 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
					<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Do not disturb
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<Button
									Icon={BellSnoozeIcon}
									type="secondary"
									onClick={() => {
										updateSettings({
											type: 'userNotification',
											key: 'notificationsPaused',
											value: !!!settings?.userNotification?.notificationsPaused,
										});
									}}
								>
									{settings?.userNotification?.notificationsPaused
										? 'Unpause notifications'
										: 'Pause notifications'}
								</Button>
							</div>
						</dd>
					</div>
					{/*<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs text-gray-400 pt-2">
							Schedule
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-2 mb-1 ">
							<div className="text-gray-900">
								<TemplateBoolean
									value={form?.overdue}
									description={
										'Turn notifications on/off between certain times'
									}
									onChange={(index, value) =>
										setForm({ ...form, overdue: value })
									}
								/>
							</div>
						</dd>
					</div>*/}
					{/*<div className="pt-2 sm:flex">
						<dt className="text-gray-500 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs pt-2">
							Do not notify me between
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-1 mb-1 ">
							<div className="text-gray-900 flex items-center justify-between gap-x-4">
								<TemplateDropdown
									className={'w-72'}
									options={NOTIFY_OPTIONS}
									value={contractForm?.time}
									onChange={(index, value) =>
										setContractForm({ ...contractForm, time: value })
									}
								/>{' '}
								and{' '}
								<TemplateDropdown
									className={'w-72'}
									options={NOTIFY_OPTIONS}
									value={contractForm?.time}
									onChange={(index, value) =>
										setContractForm({ ...contractForm, time: value })
									}
								/>
							</div>
						</dd>
					</div>*/}
					{/*<div className="pt-2 sm:flex">
						<dt className="text-gray-500 sm:w-64 sm:flex-none sm:pr-6 flex  mt-2 text-xs pt-2">
							Do not notify me on
						</dt>
						<dd className="mt-1 flex justify-between gap-x-6 sm:flex-auto mt-1 mb-1 ">
							<div className="text-gray-900 flex items-center justify-between gap-x-4">
								<span className="isolate inline-flex rounded-md shadow-sm">
									<button
										type="button"
										className="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Mon
									</button>
									<button
										type="button"
										className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Tue
									</button>
									<button
										type="button"
										className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Wed
									</button>
									<button
										type="button"
										className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Thur
									</button>
									<button
										type="button"
										className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Fri
									</button>
									<button
										type="button"
										className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Sat
									</button>
									<button
										type="button"
										className="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
									>
										Sun
									</button>
								</span>
							</div>
						</dd>
					</div>*/}

					{/*<div className="pt-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 flex mt-2 text-xs text-gray-400">
							Additional users to notify
						</dt>
						<dd className="mt-1 flex flex-col justify-between gap-x-6 sm:mt-0 sm:flex-auto">
							<div className="text-gray-900">
								<TemplateTeamMembers
									className={'w-72'}
									members={{
										rows: teamMembers?.rows?.map((member) => ({
											...member,
											type: 'person',
										})),
									}}
									onChange={(index, member) =>
										setForm({
											...form,
											members: [...form?.members, member?.id],
										})
									}
									skip={form?.members}
									CustomOption={({ innerProps, isDisabled, ...rest }) => {
										return !isDisabled ? (
											<div
												{...innerProps}
												className={'cursor-pointer hover:bg-gray-100'}
											>
												<div className="flex items-center py-3 px-5">
													<AvatarGenerated
														type={rest.data.type}
														id={
															rest.data.type === 'person'
																? getUserFullName(rest.data.contact)
																: rest.data.value
														}
														size={'xs'}
													/>

													<span className="ml-3 text-sm">
														{rest.data.label}
														<br />
														<span className="text-xxs text-gray-500">
															{rest?.data?.contact?.email}
														</span>
													</span>
												</div>
											</div>
										) : null;
									}}
								/>
							</div>
							<ul className="divide-y divide-gray-100 w-72 mt-4">
								{form?.members?.map((memberId, i) => {
									const member = teamMembers?.rows?.find(
										(o) => o.id === memberId
									);
									return (
										<li className="flex items-center text-gray-500 py-1.5 group justify-between">
											<div className="flex items-center">
												<AvatarGenerated
													id={member?.id}
													size="xxs"
													type="person"
												/>{' '}
												<span className="ml-3 text-xs">
													{getUserFullName(member)}
												</span>
											</div>
											<div
												className="opacity-0 group-hover:opacity-100 transition duration-200 ease-in-out cursor-pointer px-3 py-1.5"
												onClick={() =>
													setForm({
														...form,
														members: [
															...form?.members?.filter((o) => o !== member?.id),
														],
													})
												}
											>
												<XMarkIcon className="w-4 h-4 text-gray-400" />
											</div>
										</li>
									);
								})}
							</ul>
						</dd>
					</div>*/}
				</dl>
				{/*<div className="flex justify-end">
					<Button
						onClick={() =>
							updateSettings({
								type: 'company',
								key: 'serviceNotifications',
								value: { ...form, scheduled: form?.scheduled?.value },
							})
						}
						disabled={isLoadingSettings || isUpdatingSettings}
					>
						{isUpdatingSettings ? 'Saving...' : 'Save'}
					</Button>
				</div>*/}
			</div>

			<div className="mt-6">
				<div className="grid grid-cols-3 text-xs text-gray-600 py-5">
					<div className="col-span-2">
						<h2 className="text-base font-semibold leading-6 text-gray-900">
							Notifications
						</h2>
					</div>
					<div className="col-span-1 font-medium">Email</div>
					{/*<div className="col-span-1 font-medium">Push</div>*/}
				</div>

				<div className="divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
					<div className="grid grid-cols-3 flex items-center py-5">
						<div className="col-span-2">
							<span className="flex flex-grow flex-col">
								<span className="text-xs font-medium text-gray-900">
									Contract Expiring
								</span>
								<span className="text-xxs text-gray-500 text-xs font-normal">
									Send reminder before contract expires
								</span>
							</span>
						</div>
						<div className="col-span-1">
							<TemplateBoolean
								value={settings?.userNotification['contract:expiring:email']}
								onChange={(index, value) =>
									updateSettings({
										type: 'userNotification',
										key: 'contract:expiring:email',
										value,
									})
								}
							/>
						</div>
						{/*<div className="col-span-1">
							<TemplateBoolean
								value={form?.overdue}
								onChange={(index, value) => {}}
								disabled
							/>
						</div>*/}
					</div>
					<div className="grid grid-cols-3 flex items-center py-5">
						<div className="col-span-2">
							<span className="flex flex-grow flex-col">
								<span className="text-xs font-medium text-gray-900">
									Contract Expired
								</span>
								<span className="text-xxs text-gray-500 text-xs font-normal">
									Send reminder on the day a contract expires
								</span>
							</span>
						</div>
						<div className="col-span-1">
							<TemplateBoolean
								value={settings?.userNotification['contract:expired:email']}
								onChange={(index, value) =>
									updateSettings({
										type: 'userNotification',
										key: 'contract:expired:email',
										value,
									})
								}
							/>
						</div>
						{/*<div className="col-span-1">
							<TemplateBoolean
								value={form?.overdue}
								onChange={(index, value) =>
									setForm({ ...form, overdue: value })
								}
							/>
						</div>*/}
					</div>
				</div>
			</div>
		</>
	);
};

export default NotificationSettings;
